import axios from "axios";

// Ricava la data (YYYY-MM-DD) di un ordine: usa orderDate, altrimenti la data in coda all'orderId
export const getOrderDay = (ord) => {
  if (ord.orderDate) return String(ord.orderDate).slice(0, 10);
  const m = String(ord.orderId || "").match(/(\d{4}-\d{2}-\d{2})$/);
  return m ? m[1] : "";
};

// Data odierna in formato YYYY-MM-DD basata sull'ora locale (evita disallineamenti UTC)
export const todayStr = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

// Recupera gli ordini con data antecedente a oggi e stato diverso da "evaso"
export const fetchPastUnfulfilledOrders = async () => {
  const { data } = await axios.get("/api/orders");
  const oggi = todayStr();
  return (Array.isArray(data) ? data : [])
    .filter((ord) => {
      const day = getOrderDay(ord);
      if (!day || day >= oggi) return false; // solo giorni antecedenti a oggi
      return (ord.status || "").toLowerCase() !== "evaso";
    })
    .sort((a, b) => getOrderDay(a).localeCompare(getOrderDay(b)));
};
